import { EntityState } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../app/hooks';
import Loading from '../../../../components/Loading/Loading';
import { useLazyGetAllProjectByOrganizationQuery } from '../../../project/api/projectApiSlice';
import { Project } from '../../../project/types/types';
import { useAddRecentMutation } from '../../api/apiSlice';
import { setProject } from '../../appSlice/appslice';
import HomeProjectAllPresentation from '../../presentation/HomeProjectAllPresentation/HomeProjectAllPresentation';
import { HomeProjectAllContainerProps } from '../../types/types';

const HomeProjectAllContainer: React.FC<HomeProjectAllContainerProps> = ({
  organizationID,
  term,
  onTerm,
  projects,
}) => {
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const [getAllProjectByOrganization, { isLoading, isError, isSuccess }] =
    useLazyGetAllProjectByOrganizationQuery();

  const [
    addRecent,
    {
      isLoading: recentLoading,
      // isError: recentError,
      // isSuccess: recentSuccess,
    },
  ] = useAddRecentMutation();
  const [projectsState, setProjectState] =
    useState<EntityState<Project> | null>(null);
  useEffect(() => {
    setProjectState(projects);
  }, [projects]);
  useEffect(() => {
    (async () => {
      if (organizationID) {
        try {
          const projects = await getAllProjectByOrganization({
            organizationId: organizationID,
            term: term,
          }).unwrap();
          setProjectState(projects!);
        } catch (error) {
          console.error(error);
        }
      }
    })();
  }, [organizationID, term]);

  const onSelectProject = async (project: Partial<Project> | null) => {
    try {
      await addRecent({
        organization: organizationID as any,
        project: project!,
      }).unwrap();
      dispatch(setProject(project));
      navigation('/student');
    } catch (error) {
      console.log('this is error');
      console.error(error);
    }
  };

  let content;
  if (isLoading || recentLoading) {
    content = <Loading />;
  } else if (isError) {
    content = <h1>SomeThing Went Wrong</h1>;
  } else if (isSuccess || projects?.ids?.length! > 0) {
    content = (
      <HomeProjectAllPresentation
        project={projectsState}
        onSelectProject={onSelectProject}
      />
    );
  }

  return <>{content}</>;
};

export default HomeProjectAllContainer;
